import { useIntl } from "react-intl";

import type { PaymentMethod } from "@/app/payments/types";
import { formatCurrency } from "@/utils/currency";

interface Props {
  promoCodeDiscount?: number;
  totalPrice: number;
  paymentMethod: PaymentMethod;
}

export const PaymentDetails = ({
  promoCodeDiscount,
  totalPrice,
  paymentMethod,
}: Props) => {
  const intl = useIntl();

  const getPaymentMethodLabel = (method: PaymentMethod) => {
    switch (method) {
      case "checkout":
        return intl.formatMessage({
          defaultMessage: "Debit Card",
          description: "Payment method option label: debit card",
        });
      case "qiAccount":
        return intl.formatMessage({
          defaultMessage: "Qi",
          description: "Payment method label for the QI card",
        });
      case "bnpl":
        return intl.formatMessage({
          defaultMessage: "Pay later",
          description:
            "Short label for the pay-later / instalment payment option",
        });
      default:
        return intl.formatMessage({
          defaultMessage: "Debit Card",
          description: "Payment method option label: debit card",
        });
    }
  };

  return (
    <div className="section-card mt-2 flex flex-col gap-2 text-sm">
      {promoCodeDiscount ? (
        <div className="flex justify-between">
          <div className="text-text-tertiary">
            {intl.formatMessage({
              defaultMessage: "Promo code discount",
              description:
                "Line item label for the promo code discount in the price summary",
            })}
          </div>
          <div className="font-bold text-core-accent-500">
            {formatCurrency(promoCodeDiscount)}
          </div>
        </div>
      ) : null}

      <div className="flex justify-between">
        <div className="text-text-tertiary">
          {intl.formatMessage({
            defaultMessage: "Total",
            description: "Generic 'Total' label in price summary tables",
          })}
        </div>
        <div className="font-bold text-text-primary">
          {formatCurrency(totalPrice)}
        </div>
      </div>

      <div className="flex justify-between">
        <div className="text-text-tertiary">
          {intl.formatMessage({
            defaultMessage: "Payment method",
            description:
              "Label for the selected payment method shown in the booking summary",
          })}
        </div>
        <div className="font-bold text-text-primary">
          {getPaymentMethodLabel(paymentMethod)}
        </div>
      </div>
    </div>
  );
};
